import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "generictermsofuse",
    templateUrl: "./generictermsofuse.component.html",
    standalone: false
})
export class GenericTermsOfUse implements OnInit {

    constructor(private activatedRoute: ActivatedRoute) {

    }

    ngOnInit(): void {
    }
}